import React, { useEffect, useState } from "react";
import {
  CustomArrowDropDownIcon,
  CustomArrowRightIcon,
} from "../CustomComponents/CustomIcon/CustomIcon";
import CustomTreeItem from "../CustomComponents/CustomTreeItem/CustomTreeItem";
import CustomTreeView from "../CustomComponents/CustomTreeView/CustomTreeView";
import { useStyles } from "../../assets/jss/GroupHierarchy";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import groupIcon from "../../assets/images/addGroup.svg";
import { adminGetGroupHierarchy } from "../../services/AdminUserService";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { getUserData } from "../../services/LocalStorageService";
import { useTranslation } from "react-i18next";

export default function GroupHierarchy(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [groupHierarchyData, setGroupHierarchyData] = useState<any>(null);
  const [defaultExpanded, setDefaultExpanded] = useState(props.defaultExpanded);
  const [defaultSelected, setDefaultSelected] = useState(props.defaultSelected);
  const [isApiFailed, setIsApiFailed] = useState(false);
  const [isApi, setIsApi] = useState(false);
  const [statusValue, setStatusValue] = React.useState<any>();
  const [alertMessage, setAlertMessage] = React.useState("");
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);
  const [loggedInUserData] = useState<any>(getUserData);
  const [isSelectionDisabled, setIsSelectionDisabled] = useState(true);
  const [selectedData, setSelectedData] = useState(null);
  const [expanded, setExpanded] = React.useState<string[]>([]);
  const [selected, setSelected] = React.useState<string[]>([]);

  const changeApiStatusCodeFunc = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue(status.code);
      setAlertMessage(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen(true);
    }
  };

  useEffect(() => {
    setIsSelectionDisabled(props.selectionDisabled)
  }, [props.selectionDisabled])

  useEffect(() => {
    async function getGroupHierarchy() {
      setStatusValue(null);
      setIsApi(true);
      setAlertMessage("");
      setIsAlertOpen(false);
      const data = await adminGetGroupHierarchy(defaultSelected);
      if (
        data &&
        (data.status.code === 0 ||
          data.status.code === 200 ||
          data.status.code === 201) &&
        data.content
      ) {
        setIsApi(false);
        setIsApiFailed(false);
        setGroupHierarchyData(data.content);
        props.setGroupHierarchyData(data.content);
      } else {
        setIsApi(false);
        setIsApiFailed(true);
        changeApiStatusCodeFunc(data.status);
      }
    }
    if (!groupHierarchyData) {
      getGroupHierarchy();
    }
    return () => {
      setIsApi(false);
      setIsApiFailed(false);
    }
  }, []);

  const handleToggle = (event: React.ChangeEvent<{}>, nodeIds: string[]) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (event: React.ChangeEvent<{}>, nodeIds: string[]) => {
    setSelectedData({ event: event, value: nodeIds })
    setSelected(nodeIds);
  };

  const renderTree = (nodes: any) => {
    return (<CustomTreeItem
      className={classes.nodeLabelRoot}
      key={nodes.id}      
      nodeId={nodes.id ? nodes.id : "defaultNodeId"}
      label={
        <CustomBox className={classes.nodeLabel}>
          <img src={groupIcon} className={classes.nodeLabelIcon} />
          <CustomTypography className={classes.nodeLabelName}>
            {nodes.name}
          </CustomTypography>
          <CustomTypography className={classes.nodeLabelCount}>
            {nodes.childCount}
          </CustomTypography>
        </CustomBox>
      }
    >
      {Array.isArray(nodes.childGroups)
        ? nodes.childGroups.map((node) => renderTree(node))
        : null}
    </CustomTreeItem>)
  }

  useEffect(() => {
    setDefaultExpanded([...props.defaultExpanded]);
  }, [props.defaultExpanded]);

  useEffect(() => {
    setDefaultSelected(props.defaultSelected);
  }, [props.defaultSelected]);

  useEffect(() => {
    setGroupHierarchyData({ ...props.groupHierarchyData });
  }, [props.groupHierarchyData]);

  useEffect(() => {
    if (selectedData && selectedData.value && !isSelectionDisabled) { 
      props.onHierarchySelectionChange({ target: { value: selectedData.value } });
    }
  }, [selectedData]); 

  return (
    <>
      {isApi && <CustomBox><CustomCircularProgress /></CustomBox>}
      {!isApi && isApiFailed && t("SOMETHING_WENT_WRONG")}
      {!isApiFailed &&
        !isApi &&
        !groupHierarchyData &&
        t("GROUP_HIERARCHY_NOT_FOUND")}
      {!isApiFailed && !isApi && groupHierarchyData && defaultExpanded && defaultExpanded.length && defaultSelected ? (
        <CustomTreeView
          className={classes.hierarchy}
          disableSelection={isSelectionDisabled}
          expanded={(expanded.length === 0)?defaultExpanded:expanded}
          selected={(selected.length === 0)?defaultSelected.toString():selected}
          defaultCollapseIcon={<CustomArrowDropDownIcon />}
          //expanded={defaultExpanded}
          defaultExpandIcon={<CustomArrowRightIcon />}
          //selected={defaultSelected.toString()}
          // onNodeSelect={(e, v) => {setSelectedData({ event: e, value: v })}}
          // onNodeSelect={(e, v)=>handleNodeSelect(e,v)}
          onNodeToggle={handleToggle}
          onNodeSelect={handleSelect}
        >
          {renderTree(groupHierarchyData)}
        </CustomTreeView>
      ) : null}
      <ErrorAlert
        code={statusValue}
        message={alertMessage}
        isOpen={isAlertOpen}
        isClose={(isClose) => setIsAlertOpen(!isClose)}
      />
    </>
  );
}
